// Facile deep clone of the given object
export const clone = obj => JSON.parse(JSON.stringify(obj));
